function safePush(listName, payload) {
  try {
    var list = window[listName];
    if (!list || typeof list.push !== 'function') {
      window[listName] = [];
      list = window[listName];
    }
    list.push(payload);
  } catch (error) {
    console.error(error);
  }
}

export const clickPoint = function (data) {
  if (!data) {
    return;
  }
  var type = data.eventType || '';
  var reason = data.eventReason || '';
  var value = data.eventValue || '';
  if (!type || !reason) {
    return;
  }
  point({
    eventName: 'click_button',
    eventType: type,
    eventReason: reason,
    eventValue: value,
  });
};

export const viewPoint = function (data) {
  if (!data) {
    return;
  }
  var type = data.eventType || '';
  var reason = data.eventReason || '';
  var value = data.eventValue || '';
  if (!type) {
    return;
  }
  point({
    eventName: 'view_page',
    eventType: type,
    eventReason: reason,
    eventValue: value,
  });
};

export const point = function (data) {
  if (!data || !data.eventName) {
    return;
  }
  var gameId = window.gameId;

  // 上报BI
  safePush('activityDataLayer', {
    eventName: data.eventName || '',
    eventType: data.eventType || '',
    eventReason: data.eventReason || '',
    eventValue: data.eventValue || '',
    eventReward: data.eventReward || '',
    aid: 'globalexchange',
    gameId: gameId,
  });

  // 上报GA
  safePush('dataLayer', {
    event: 'creatEvt',
    manualEvent: data.eventType || '',
    customValue: data.eventReason || '',
  });

  if (window.pointTest) {
    console.log(data, gameId);
  }
};
